import React, { useEffect, useState } from "react";
import NormalSelect from "../form/HorizontalNormalSelect";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalTextArea from "../form/HorizontalNormalTextarea";
import { Card, CardBody } from "../card/card";
import { task as taskApi } from "../../api";
import { toast } from "react-toastify";
import { useDebouncedEffect } from "../../lib/useDebounceEffect";
import { renderImage } from "../../utils/helper";

export const TaskActionItem = ({ indexTask, task }) => {
  const [currentTask, setCurrentTask] = useState(task);
  const [openComment, setOpenComment] = useState(false);
  const [openImage, setOpenImage] = useState(false);
  const [preview, setPreview] = useState();
  const [selectedFile, setSelectedFile] = useState("");

  const [text, setText] = useState("");
  const [isValueChanging, setIsValueChanging] = useState(false);

  const handleOpenComment = () => {
    setOpenComment(true);
  };

  const handleCloseComment = () => {
    setOpenComment(false);
  };
  const handleOpenImage = () => {
    setOpenImage(true);
  };

  const handleCloseImage = () => {
    setOpenImage(false);
  };

  const updateTask = async () => {
    try {
      const result = await taskApi.update(
        currentTask.id,
        currentTask,
        selectedFile
      );
      if (result.ok) {
        toast.success(`Task no ${indexTask + 1} updated`);
      } else {
        toast.error("Task failed to update");
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleOnChange = (e) => {
    let key = e.target.name;
    setCurrentTask((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));

    if (key == "task_option_selected") {
      setIsValueChanging(true);
    }
  };

  useDebouncedEffect(
    () => {
      if (isValueChanging) {
        updateTask();
      }
    },
    1250,
    [currentTask.task_option_selected]
  );

  useEffect(() => {
    if (currentTask.task_photo) {
      setTimeout(() => {
        setPreview(
          renderImage(`/machine/attachment/` + currentTask.task_photo)
        );
      }, 1000);
    }
  }, [currentTask.task_photo]);

  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const submitNote = async () => {
    await updateTask();
    handleCloseComment();
  };

  const submitPhoto = async () => {
    await updateTask();
    handleCloseImage();
  };

  return (
    <>
      <ConfirmationDlg
        type="submit"
        onClose={handleCloseComment}
        open={openComment}
        onSubmit={submitNote}
      >
        <NormalTextArea
          label={"Note"}
          onchange={handleOnChange}
          name={"task_note"}
          value={currentTask.task_note}
        />
      </ConfirmationDlg>

      <ConfirmationDlg
        type="submit"
        onClose={handleCloseImage}
        open={openImage}
        onSubmit={submitPhoto}
      >
        <Card>
          <CardBody>
            <label htmlFor="files">
              {preview ? (
                <>
                  <img src={preview} className="img-thumbnail" alt="" />
                  <div
                    style={{
                      textAlign: "center",
                      cursor: "pointer",
                      marginTop: "5px",
                    }}
                  >
                    Change Photo <i className="fa fa-camera"></i>
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      minHeight: "150px",
                      alignItems: "center",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    <i className="fa fa-camera"></i>
                    <div>Add a Photo</div>
                  </div>
                </>
              )}
            </label>
            <input
              id="files"
              onChange={onSelectFile}
              style={{ visibility: "hidden", position: "absolute" }}
              type="file"
              accept="image/png, image/jpeg"
            />
          </CardBody>
        </Card>
      </ConfirmationDlg>
      <tr>
        <td style={{ verticalAlign: "top" }}>{indexTask + 1}</td>
        <td style={{ verticalAlign: "top" }}>
          {currentTask.task_type == "Status" && (
            <NormalSelect
              onchange={handleOnChange}
              name={"task_option_selected"}
              value={currentTask.task_option_selected}
              label={currentTask.task_name}
              list={["Open", "In Progress", "Hold", "Complete"].map((v) => ({
                name: v,
                value: v,
              }))}
            />
          )}
          {currentTask.task_type == "Text Field" && (
            <>
              {currentTask.task_name}
              <input
                name={"task_option_selected"}
                onChange={handleOnChange}
                value={currentTask.task_option_selected}
                className="form-control mt-2"
                type="text"
              />
            </>
          )}
          {currentTask.task_type == "Multiple Choice" && (
            <NormalSelect
              name={"task_option_selected"}
              onchange={handleOnChange}
              value={currentTask.task_option_selected}
              label={currentTask.task_name}
              list={currentTask.task_option.map((v) => ({ name: v, value: v }))}
            />
          )}
        </td>
        <td style={{ verticalAlign: "middle" }}>
          <div className="mt-3">
            <button
              onClick={handleOpenComment}
              className="btn btn-sm btn-outline-theme"
              style={{ marginRight: 5 }}
            >
              <i className="bi bi-chat-left-text"></i>
            </button>

            <button
              onClick={handleOpenImage}
              className="btn btn-sm btn-outline-theme"
            >
              <i className="bi bi-image"></i>
            </button>
          </div>
        </td>
        <td style={{ verticalAlign: "top" }}></td>
      </tr>
    </>
  );
};
